import bem from '../utils/bem'
import './sliding-box.scss'


export default function SlidingBox({open, children}) {
    return <div className={bem("sliding-box").m({open})}>
        {children}
    </div>
}